module.exports = __webpack_public_path__ + "img/cb9-r-r1.752719a4.gif";